const closeWindow = () => window.close();

export default closeWindow;
